<div class="de-dashboard-main-container">
  <div class="company-classification">
    <div class="entity-name">
      NAME: {{ regInfo?.approvedName }}
    </div>
    <div class="entity-status">
      STATUS: {{ regInfo?.status }}
    </div>
    <div class="entity-address">
      ADDRESS: {{ regInfo?.address }}
    </div>
    <div class="entity-commencement-date">
      REGISTRATION DATE: {{ regInfo?.registration_date | date: 'mediumDate' }}
    </div>

  </div>
  <ng-container *ngIf="classificationId == 1">
    <div class="company-features">
      <div class="features">
        <a class="de-item" routerLink="/company-registration/company-application">
                <span class="de-icon">
                  <i class="bi bi-buildings-fill"></i>
                </span>
          <span class="de-text">
                  Business Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/proprietors">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Particulars of Proprietors
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/nature-of-business">
                <span class="de-icon">
                  <i class="bi bi-briefcase-fill"></i>
                </span>
          <span class="de-text">
                  Nature of Business
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/business-name-documents">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </span>
          <span class="de-text">
                  Document Upload
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/business-name-preview">
                <span class="de-icon">
                  <i class="bi bi-binoculars"></i>
                </span>
          <span class="de-text">
                  Preview Application
                </span>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="classificationId == 2">
    <div class="company-features">
      <div class="features">
        <a class="de-item" routerLink="/company-registration/company-application">
                <span class="de-icon">
                  <i class="bi bi-buildings-fill"></i>
                </span>
          <span class="de-text">
                  Company Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/object-of-memorandum">
                <span class="de-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
          <span class="de-text">
                  Objects of Memorandum
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/articles-of-association">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-medical-fill"></i>
                </span>
          <span class="de-text">
                  Articles of Association
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/directors">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Directors
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/company-secretary">
                <span class="de-icon">
                  <i class="bi bi-person-rolodex"></i>
                </span>
          <span class="de-text">
                  Secretary
                </span>
        </a>
        <ng-container *ngIf="companyType?.name !== 'PRIVATE_COMPANY_LIMITED_BY_GUARANTEE'">
          <button (click)="checkForOngoingShareUpdate();" class="de-item" [disabled]="loading">
            <span class="de-icon" *ngIf="!loading"><i class="bi bi-wallet-fill"></i></span>
            <span class="de-icon" *ngIf="loading"><loading-icon></loading-icon></span>
            <span class="de-text">Statement of Capital</span>
          </button>
        </ng-container>

        <ng-container *ngIf="companyType?.name === 'PRIVATE_COMPANY_LIMITED_BY_GUARANTEE'">
          <a class="de-item" [routerLink]="'/company-registration/statement-of-guarantee'">
            <span class="de-icon">
              <i class="bi bi-person-plus"></i>
            </span>
            <span class="de-text">Statement of Guarantee</span>
          </a>
        </ng-container>

        <a class="de-item" [routerLink]="'/company-registration/psc'">
            <span class="de-icon"><i class="bi bi-person-plus"></i>
            </span>
          <span class="de-text">Persons with significant control</span>
        </a>
        <a class="de-item" routerLink="/company-registration/statement-of-compliance">
                <span class="de-icon">
                  <i class="bi bi-person-lines-fill"></i>
                </span>
          <span class="de-text">
                  Statement of Compliance
          </span>
        </a>
        <a class="de-item" routerLink="/company-registration/company-documents">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </span>
          <span class="de-text">
                  Document Upload
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/company-preview">
                <span class="de-icon">
                  <i class="bi bi-binoculars"></i>
                </span>
          <span class="de-text">
                  Preview Application
                </span>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="classificationId == 3">
    <div class="company-features">
      <div class="features">
        <a class="de-item" routerLink="/company-registration/company-application">
                <span class="de-icon">
                  <i class="bi bi-buildings-fill"></i>
                </span>
          <span class="de-text">
                  Company Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/trustees">
                <span class="de-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
          <span class="de-text">
                  Trustees Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/trustee-secretary">
                <span class="de-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
          <span class="de-text">
                  Trustee Secretary
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/trustee-aims-and-objectives">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Aims & Objectives
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/constitution">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Constitution
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/meetings">
                <span class="de-icon">
                  <i class="bi bi-wallet-fill"></i>
                </span>
          <span class="de-text">
                  Meetings
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/source-of-income">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Source of Income
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/publications">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Publications
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/documents">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </span>
          <span class="de-text">
                  Document Upload
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/incorporated-trustee-preview">
                <span class="de-icon">
                  <i class="bi bi-binoculars"></i>
                </span>
          <span class="de-text">
                        Preview Application
                </span>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="classificationId == 4">
    <div class="company-features">
      <div class="features">
        <a class="de-item" routerLink="/company-registration/company-application">
                <span class="de-icon">
                  <i class="bi bi-buildings-fill"></i>
                </span>
          <span class="de-text">
                  Company Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/partners">
                <span class="de-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
          <span class="de-text">
                  Particulars of Partners
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/lp-nature-of-business">
                <span class="de-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
          <span class="de-text">
                  Nature of Business
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/partnership-agreement">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Partnership Agreement
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/lp-document-upload">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </span>
          <span class="de-text">
                  Document Upload
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/lp-preview">
                <span class="de-icon">
                  <i class="bi bi-binoculars"></i>
                </span>
          <span class="de-text">
                  Preview Application
                </span>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="classificationId == 5">
    <div class="company-features">
      <div class="features">
        <a class="de-item" routerLink="/company-registration/company-application">
                <span class="de-icon">
                  <i class="bi bi-buildings-fill"></i>
                </span>
          <span class="de-text">
                  Company Details
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/llp-partners">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Partners Appointment
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/psc">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  Persons with significant control
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/llp-partnership-agreement">
                <span class="de-icon">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
          <span class="de-text">
                  LLP Partnership Agreement
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/llp-document-upload">
                <span class="de-icon">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </span>
          <span class="de-text">
                  Document Upload
                </span>
        </a>
        <a class="de-item" routerLink="/company-registration/llp-preview">
                <span class="de-icon">
                  <i class="bi bi-binoculars"></i>
                </span>
          <span class="de-text">
                  Preview Application
                </span>
        </a>
      </div>
    </div>
  </ng-container>
</div>
